// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0c1o8l{display:inline-block}
._3se11kw7 >svg{fill:inherit}
._4t3i1tcg{height:24px}
._4t3i1ylp{height:40px}
._4t3i7vkz{height:1pc}
._4t3ickbl{height:3pc}
._4t3izwfg{height:2pc}
._kqswh2mm{position:relative}
._lswu1xf6{fill:var(--logo-fill)}
._o5724jg8{white-space:normal}
._syaz1vry{color:var(--logo-color)}
._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}
._vc881r31 stop{stop-color:currentColor}
._vwz4kb7n{line-height:1}
._zbji1osq >svg{height:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-extractors/node_modules/@atlaskit/logo/dist/esm/wrapper.compiled.css"],"names":[],"mappings":"AAAA,WAAW,oBAAoB;AAC/B,gBAAgB,YAAY;AAC5B,WAAW,WAAW;AACtB,WAAW,WAAW;AACtB,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB,WAAW,iBAAiB;AAC5B,WAAW,qBAAqB;AAChC,WAAW,kBAAkB;AAC7B,WAAW,uBAAuB;AAClC,WAAW,wBAAwB,CAAC,oBAAoB,CAAC,gBAAgB;AACzE,gBAAgB,uBAAuB;AACvC,WAAW,aAAa;AACxB,gBAAgB,WAAW","sourcesContent":["._1e0c1o8l{display:inline-block}\n._3se11kw7 >svg{fill:inherit}\n._4t3i1tcg{height:24px}\n._4t3i1ylp{height:40px}\n._4t3i7vkz{height:1pc}\n._4t3ickbl{height:3pc}\n._4t3izwfg{height:2pc}\n._kqswh2mm{position:relative}\n._lswu1xf6{fill:var(--logo-fill)}\n._o5724jg8{white-space:normal}\n._syaz1vry{color:var(--logo-color)}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}\n._vc881r31 stop{stop-color:currentColor}\n._vwz4kb7n{line-height:1}\n._zbji1osq >svg{height:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
